<template>
  <div class="home">
    <span v-if="loading">Loading…</span>
    <ul v-else class="movies">
      <h1>Our Movies</h1>
      <li v-for="movie in movies" :key="movie.title" class="movie-item">
        <h3>{{ movie.title }}</h3>
        <p>{{movie.book}}</p>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  data() {
    return {
      loading: false
    };
  },
  computed: {
    movies() {
      return this.$store.state.movies;
    }
  },
  created() {
    this.loading = true;
    this.$store.dispatch("fetchMovies").then(movies => {
      this.loading = false;
    });
  }
};
</script>

<style scoped>
.movies {
  list-style: none;
  text-align: left;
}

.movie-item + .movie-item {
  border-top: 1px solid rgba(0, 0, 0, 0.1);
}
</style>
